import { getScores, isMissionComplete, rankScores } from '../selectors';
import type { GameResult, PlayerId } from '../types';
import type { Ctx } from './context';

export function endGame(ctx: Ctx, reason: GameResult['reason'], winner: PlayerId): void {
  const { s } = ctx;
  s.result = { reason, winner, scores: rankScores(getScores(s)) };
  s.phase = 'over';
  s.pending = null;
  s.reinforcements = 0;
  ctx.events.push({ type: 'gameOver', result: s.result });
}

/** Verifica último sobrevivente e missões. O jogador que agiu tem prioridade. */
export function checkVictory(ctx: Ctx, actor: PlayerId): void {
  const { s } = ctx;
  if (s.phase === 'over' || s.phase === 'setup') return;
  const alive = s.players.filter((p) => p.alive);
  if (alive.length === 1) {
    endGame(ctx, 'lastStanding', alive[0].id);
    return;
  }
  const order = [actor, ...s.players.map((p) => p.id).filter((id) => id !== actor)];
  for (const id of order) {
    const pl = s.players[id];
    if (!pl?.alive) continue;
    if (isMissionComplete(s, id, pl.mission)) {
      ctx.events.push({ type: 'missionComplete', player: id });
      endGame(ctx, 'mission', id);
      return;
    }
  }
}

/** Fim da rodada limite sem missão cumprida: vence a maior pontuação. */
export function serverSave(ctx: Ctx): void {
  const { s } = ctx;
  const ranked = rankScores(getScores(s)).filter((l) => s.players[l.player].alive);
  endGame(ctx, 'serverSave', ranked[0].player);
}
